import { capabilities } from 'navigation-components/capabilities';
import { useInvokeCapability } from 'navigation-components/consumer/hooks';
import Raven from 'raven-js';
import { useCallback, useEffect } from 'react';
const useInterceptAnchorNavigation = () => {
  const navigateToUrl = useInvokeCapability(capabilities.NAVIGATE_TO_CAP);

  // Separate async function to handle the anchor click
  const handleAnchorClickAsync = useCallback(async (event, anchor) => {
    event.preventDefault();
    const url = anchor.href;
    const targetAttr = anchor.getAttribute('target');

    // If the anchor has an onclick attribute, execute it
    const onClick = anchor.onclick;
    if (onClick) {
      try {
        await onClick.call(anchor, event);
      } catch (error) {
        Raven.captureException(error);
      }
    }
    try {
      if (event.shiftKey) {
        navigateToUrl({
          url,
          openInNewWindow: true
        });
      } else if (event.ctrlKey || event.metaKey || targetAttr === '_blank') {
        navigateToUrl({
          url,
          openInNewTab: true
        });
      } else {
        navigateToUrl({
          url
        });
      }
    } catch (error) {
      Raven.captureException(error);
    }
  }, [navigateToUrl]);
  const handleAnchorClick = useCallback(event => {
    let target = event.target;

    // Check if the target or any of its ancestors have the data-ignore-navigation attribute
    if (target.closest('[data-ignore-navigation="true"]')) {
      return;
    }

    // Move up the DOM tree to find if the click is within an anchor tag
    while (target && target.tagName !== 'A') {
      target = target.parentElement;
    }
    if (target && target.tagName === 'A') {
      // Finally if any parent has a data-tab-id then return
      // This is because we cannot control the ActionsCollapser menu that pops up should the tabs ever
      // have the "More ↓" overflow menu, it is rendered outside of our usual data-ignore-navigation
      // container so use the tab attributes to infer we should ignore the click
      const parent = target.closest('[data-tab-id]');
      if (parent) {
        return;
      }
      void handleAnchorClickAsync(event, target);
    }
  }, [handleAnchorClickAsync]);
  useEffect(() => {
    document.addEventListener('click', handleAnchorClick);
    return () => {
      document.removeEventListener('click', handleAnchorClick);
    };
  }, [handleAnchorClick]);
};
export default useInterceptAnchorNavigation;